<template>
    <div class="container" style="width: 100vw; height: 100vh;">
    <div style="margin-top: -30px;">
    <span class="text-danger fs-3 fw-bold">LTC Red Army</span>
    <br>
    <span class="fs-5 fw-bold" style="color:rgb(137, 81, 40)">(User Managment <i class="fa-solid fa-user-pen"></i>)</span>
    </div>
         <div class="row" style="padding: 50px 5px 0px 5px">
                  <div class="col-4 " style="background-color: #EAEDED;height: 35px;padding-top: 5px;border-radius: 2px;">
                    <label for="username" class="form-label " >
                      <i class="fas fa-user"></i>
                    </label>
                  </div>
                  <div class="col-6" style="height: 35px;overflow-y: hidden;">
                    <input type="text" class="form-control" style="width: 100%;height: 35px;font-size: 12px;" placeholder="Employee number, Name, Phone" v-model="keywordToSearch">
                  </div>
                  <div class="col-2 " style="height: 35px;">
                  <button type="button" class="btn btn-success" style="width: 100%;" @click="clickBtnSearch();">
                      <i class="fa-solid fa-search"></i>
                  </button>
                  </div>
        </div>   
        <!-- <div class="row" style="padding: 3px 5px 0px 5px">
                  <div class="col-4 " style="background-color: #EAEDED;height: 35px;padding-top: 5px;border-radius: 2px;">
                        <label for="username" class="form-label " >
                          <span class="fw-bold " style="font-size: 12px;">Role</span>
                        </label>
                      </div>
                      <div class="col-8 " style="height: 35px;">
                        <button style="height: 35px;width:100%;font-size: 12px;" class="btn btn-light dropdown-toggle" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
                          {{selectedRoleObject?selectedRoleObject.roleName:"Please select"}}
                        </button>
                        <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1" style="font-size: 12px;">
                          <li v-for="(role,index) in roles" v-bind:key="index" @click="selectedRoleObject=role">&nbsp;{{role.roleName}}&nbsp;</li>
                        </ul>
                  </div>
        </div> -->
        <!-- <div class="row" style="padding: 3px 5px 0px 5px">
              <div class="col-4 " style="background-color: #EAEDED;height: 35px;padding-top: 5px;border-radius: 2px;">
                  <label for="username" class="form-label " >
                          <span class="fw-bold " style="font-size: 12px;">Province</span>
                        </label>
                      </div>
                      <div class="col-6 " style="height: 35px;">
                        <button style="height: 35px;width:100%" class="btn btn-light dropdown-toggle" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
                          <span style="font-size: 12px;"> {{selectedProvinceObject?selectedProvinceObject.name_la+'/'+selectedProvinceObject.name_en:"Please select"}}</span>
                        </button>
                        <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1" style="font-size: 12px;">
                            <li v-for="(province, index) in provinces" v-bind:key="index" @click="selectedProvinceObject=province;">&nbsp;{{province.name_la+'/'+province.name_en}}&nbsp;</li>
                        </ul>
                  </div>
                  <div class="col-2 " style="height: 35px;">
                  <button type="button" class="btn btn-success" style="width: 100%;" @click="clickBtnSearch();">
                      <i class="fa-solid fa-search"></i>
                    </button>
                  </div>
        </div> -->
        <div class="row" style="padding: 5px 5px 0px 5px;height: 60vh;overflow-y: scroll;">
        <table class="table table-striped" style="width:100%;font-size: 12px;">
          <thead>
            <tr style="background-color:cornflowerblue">
              <th scope="col-2" style="border:1px solid black;padding-bottom:15px;font-size: 12px;">No.</th>
              <th scope="col-10" style="border:1px solid black;font-size: 12px;">
                <div class="row">
                  <div class="col-7" style="padding-top:5px;font-size: 12px;">
                    User
                  </div>
                  <div class="col-5 text-end">
                    <!-- <button type="button" class="btn btn-success" style="width:100%;font-size:12px;" @click="clickBtnSyncUserData();">
                      <i class="fa-solid fa-rotate"></i> Sync data <i class="fa-solid fa-users"></i>
                    </button> -->
                    
                  </div>
                
              </div>
              </th>
            </tr>
          </thead>
          <tbody >
            <tr v-for="(user, index) in users" v-bind:key="index" @click="clickRowUser(user);">
              <td style="border:1px solid black">{{ index+1 }}</td>
              <td class="text-start" style="border:1px solid black">
                {{user.first_name_la+' '+user.surname_la+'('+user.user_code+')'}}<br>
                <i class="fas fa-clock"></i> Create:{{dateStrFormat(user.create_date)}},
                <i class="fa-regular fa-clock"></i> Modify:{{dateStrFormat(user.last_modify_date)}}
                <br>
                <i v-if="user.status&&user.status!=0" class="fa-solid fa-check" style="color:green"></i>
                <i v-else class="fa-solid fa-xmark" style="color:red"></i>
                {{user.status&&user.status!=0?'Active':'Inactive'}},
                <i class="fa-solid fa-key" style="color:green"></i> {{user.role_name}}
                <br>
                <i class="fas fa-location-dot"></i>
                <!-- <div v-if="user.p_name_la"> -->
                {{(user.p_name_la?(user.p_name_la+'/'+user.p_name_en):'-')}}
                <!-- </div> -->
              </td>
            </tr>
          </tbody>
       </table>
      </div>

<!-- Modal User detail to Edit, Add, Delete -->
<div class="modal fade" id="modalUserDetail" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-scrollable modal-fullscreen-sm-down" >
    <div class="modal-content" >
      <div class="modal-header">
          <b>{{modalUserDetailFlagSwicthEdit?'Edit User':(modalUserDetailFlagSwicthEdit==null?'Add User':'User Details')}}</b>
        &nbsp;
        <i class="fas fa-pen-to-square" @click="modalUserDetailFlagSwicthEdit==true?modalUserDetailFlagSwicthEdit=false:modalUserDetailFlagSwicthEdit=true"></i>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body" :style='!modalUserDetailFlagSwicthEdit&&modalUserDetailFlagSwicthEdit!=null?{"pointer-events": "none","opacity": "0.4"}: {}'>
        <!-- section1 -->
        <div>  
          <div class="row" style="padding: 3px 3px 0px 3px">
            <div class="col-4 " style="background-color: #EAEDED;height: 35px;padding-top: 5px;border: 1px solid black;border-radius: 2px;">
              <label for="username" class="form-label " style="font-size: 12px;height: 35px;">User code</label>
              </div>
              <div class="col-8 " style="height: 35px;padding: 0px 1px 0px 1px;">
                <span class="input-group-text" style="font-size: 12px;height: 35px;width:100%;">{{modalUserDetailUserCode}}</span>
              </div>
          </div>
          <div class="row" style="padding: 3px 3px 0px 3px">
            <div class="col-4 " style="background-color: #EAEDED;height: 35px;padding-top: 5px;border: 1px solid black;border-radius: 2px;">
              <label for="username" class="form-label " style="font-size: 12px;height: 35px;">Mobile</label>
            </div>
            <div class="col-8 " style="height: 35px;padding: 0px 1px 0px 1px;">
              <span class="input-group-text" style="font-size: 12px;height: 35px;width:100%;">{{modalUserDetailMobile}}</span>
            </div>
          </div>

          <div class="row" style="padding: 3px 3px 0px 3px">
            <div class="col-12 text-start">
              <div class="form-check form-check-inline">
                <input class="form-check-input" type="radio" name="r1" v-model="modalUserDetailUserStatus" value="true" >
                <label class="form-check-label" for="r1" style="font-size: 12px;">Active</label>
              </div>
              <div class="form-check form-check-inline">
                <input class="form-check-input" type="radio" name="r2" v-model="modalUserDetailUserStatus" value="false">
                <label class="form-check-label" for="r2" style="font-size: 12px;">Inactive</label>
              </div>
            </div>
          </div>

          <div class="row" style="padding: 3px 3px 0px 3px">
                      <div class="col-4 " style="background-color: #EAEDED;height: 35px;padding-top: 5px;border: 1px solid black;border-radius: 2px;">
                        <label for="username" class="form-label " style="font-size: 12px;height: 35px;">
                          Role
                        </label>
                      </div>
                      <div class="col-8 " style="height: 35px;padding: 0px 1px 0px 1px;">
                        <button style="height: 35px;width:100%;font-size: 12px;" class="btn btn-light dropdown-toggle" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
                          {{modalUserDetailSeletedRole?modalUserDetailSeletedRole.roleName:"Please select"}}
                        </button>
                        <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1" style="font-size: 12px;">
                          <li v-for="(role,index) in modalUserDetailRoles" v-bind:key="index" @click="modalUserDetailSeletedRole=role">&nbsp;{{role.roleName}}&nbsp;</li>
                        </ul>
                  </div>
          </div>
        
          <div class="row" style="padding: 3px 3px 0px 3px">
            <div class="col-4 " style="background-color: #EAEDED;height: 35px;padding-top: 5px;border: 1px solid black;border-radius: 2px;">
              <label for="username" class="form-label " style="font-size: 12px;height: 35px;">Name</label>
              </div>
              <div class="col-8 " style="height: 35px;padding: 0px 1px 0px 1px;">
                <input type="text" class="form-control" v-model="modalUserDetailFirstName" style="height: 35px;width:100%"/>
              </div>
          </div>
          <div class="row" style="padding: 3px 3px 0px 3px">
            <div class="col-4 " style="background-color: #EAEDED;height: 35px;padding-top: 5px;border: 1px solid black;border-radius: 2px;">
              <label for="username" class="form-label " style="font-size: 12px;height: 35px;">Surname</label>
            </div>
            <div class="col-8 " style="height: 35px;padding: 0px 1px 0px 1px;">
              <input type="text" class="form-control" v-model="modalUserDetailSurname" style="height: 35px;width:100%"/>
            </div>
          </div>

          </div>
          <!-- section2 -->
          <hr>
          <div class="row" style="padding: 3px 3px 0px 3px">
          <span style="font-size: 12px;text-align: left;"><b>User Area</b></span>
              <table class="table table-striped">
              <thead>
                <tr>
                  <th scope="col" style="width: 15%;font-size: 12px;border:1px solid black;background-color: cornflowerblue;">No.</th>
                  <th scope="col" style="width: 85%;font-size: 12px;border:1px solid black;background-color: cornflowerblue;">
                    <span>Province</span>
                    <button v-if="modalUserDetailProvinceArea.length==0" type="button" style="float: right;" class="btn btn-success" @click="clickBtnAddProvince();">
                      <i class="fa-solid fa-plus"></i>
                    </button> 
                  </th>
                </tr>
              </thead>
              <tbody >
                <tr v-for="(userArea, index) in modalUserDetailProvinceArea" v-bind:key="index">
                  <td style="font:12px;border:1px solid black;">
                    <!-- **********DON'T REMOVE BELOW It's a manage district********** -->
                    <!-- <i class="fa-solid fa-square-minus" style="color: red;" @click="clickDeleteAreaProvince(userArea)"></i>  -->
                    {{index+1}}
                  </td>
                  <td style="padding:0px;border:1px solid black;" @click="modalUserAreaFlagAdd=false;clickRowProvince(userArea.province_code,(userArea.p_name_la+'/'+userArea.p_name_en),userArea.districts_id);">
                    <span style="font-size: 12px;"> {{ userArea.province_code+', '+userArea.p_name_la+'/'+userArea.p_name_en}}</span>
                  
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
       

       

          
      </div>
      <div class="modal-footer">
        <!-- <button @click="clickBtnDeleteQuestion();" v-if="modalUserDetailFlagSwicthEdit&&modalUserDetailFlagSwicthEdit!=null" type="button" class="btn btn-danger" data-bs-dismiss="modal">Delete</button> -->
        <button v-if="modalUserDetailFlagSwicthEdit||modalUserDetailFlagSwicthEdit==null" type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
        <button @click="clickSave()" v-if="modalUserDetailFlagSwicthEdit||modalUserDetailFlagSwicthEdit==null" type="button" class="btn btn-primary">Save</button>
      </div>
    </div>
  </div>
</div>

<!-- MODAL MODIFY USER AREA -->
<div class="modal fade" id="modalUserArea" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-scrollable modal-fullscreen-sm-down" >
    <div class="modal-content" style="min-height: 80vh;">
      <div class="modal-header">
        <!-- <h7 class="modal-title" id="exampleModalLabel"> -->
        <b>{{modalUserAreaFlagAdd?'Add user area':'User area details'}}</b>
        <!-- </h7> -->
        &nbsp;
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <!-- section1 -->
        <div>  
          <div class="row" style="padding: 50px 5px 0px 5px" :style='modalUserAreaFlagAdd?{}:{"pointer-events": "none","opacity": "0.4"}'>
              <div class="col-4 " style="background-color: #EAEDED;height: 35px;padding: 5px 0px 0px 0px;border: 1px solid black;border-radius: 2px;">
                    <label for="username" class="form-label " >
                      <span class="fw-bold " style="font-size: 12px;">Province</span>
                    </label>
              </div>
              <div class="col-8 " style="height: 35px;">
                    <button style="height: 35px;width:100%" class="btn btn-light dropdown-toggle" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
                          <span style="font-size: 12px;"> {{ modalUserAreaSelectedPname?modalUserAreaSelectedPname:'Please select' }}</span>
                    </button>
                    <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1" style="font-size: 12px;">
                        <li v-for="(province, index) in modalUserAreaProvinces" v-bind:key="index" @click="clickRowProvince(province.code,province.name_la+'/'+province.name_en);">&nbsp;{{province.name_la+'/'+province.name_en}}&nbsp;</li>
                    </ul>
              </div>
          </div>
          </div>
          <hr>
          <!-- section2 -->
          <div style="width: 100%;">
          <span style="font-size: 12px;float: left;"><b>Question Area</b></span>
              <table class="table table-striped">
              <thead>
                <tr>
                  <th scope="col" style="width: 15%;font-size: 12px;border:1px solid black;background-color: cornflowerblue;">No.</th>
                  <th scope="col" style="width: 75%;font-size: 12px;border:1px solid black;background-color: cornflowerblue;">
                    <span>District</span>                  
                  </th>
                  <!-- **********DON'T REMOVE BELOW This to manage district********** -->
                  <th scope="col" style="width: 10%;font-size: 12px;border:1px solid black;background-color: cornflowerblue;">
                  </th>
                </tr>
              </thead>
              <tbody >
                <tr v-for="(district, index) in modalUserAreaDistrictsInPv" v-bind:key="index">
                  <th scope="row" style="font:12px;border:1px solid black;">
                    {{index+1}}
                  </th>
                  <td style="padding:0px;border:1px solid black;">
                    {{ district.name_la+'/'+district.name_en }}
                  </td>
                  <!-- **********DON'T REMOVE BELOW This to manage district********** -->
                  <!-- "pointer-events": "none","opacity": "0.4"} -->
                  <td style="padding:0px;border:1px solid black;pointer-events:none;opacity:0.4">
                    <input class="form-check-input" type="checkbox" v-model="district.isActive" 
                    @change="onChangeCbDistrict(district.id)">
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
        <!-- <button type="button" class="btn btn-success" @click="clickOkChooseDistricts();">OK</button> -->
      </div>
    </div>
  </div>
</div>



    <!-- </div>

    </div> -->

        <div class="row text-center">
              <button type="submit" class="btn btn-danger" @click="$router.push('/home');" style="width:100%;" >
              <i class="fas fa-house"></i> Home
            </button>
            <!-- <div class="col-6 text-center">

            <button v-if="tabActive!=0" type="submit" class="btn btn-success" style="width:100%;" @click="clickSave();">
              <i class="fas fa-floppy-disk"></i> Send
            </button>
            </div> -->
        </div>
    </div>
    
</template>

<script>
import '@fortawesome/fontawesome-free/css/all.css'
import { Modal } from 'bootstrap'
import axios from 'axios';
import Global from './GlobalVariable';
import Service from './Service';

export default {
  name: 'SurveyPage',
  mixins: [Service],
  props: {
    msg: String
  },
  data() {
    return {
        keywordToSearch:"",
        selectedRoleObject:null,
        selectedProvinceObject:null,
        roles:[
          {"roleId":0,"roleName":"Read only"},
          {"roleId":1,"roleName":"Normal user"},
          {"roleId":2,"roleName":"Admin user"},
          {"roleId":null,"roleName":"All"},
        ],
        provinces:[],
        modalUserDetail:"",
        modalUserDetailSelectedId:null,
        modalUserDetailFlagSwicthEdit:false,
        modalUserDetailUserCode:null,
        modalUserDetailMobile:null,
        modalUserDetailUserStatus:true,
        modalUserDetailSeletedRole:null,
        modalUserDetailRoles:[
          {"roleId":0,"roleName":"Read only"},
          {"roleId":1,"roleName":"Normal user"},
          {"roleId":2,"roleName":"Admin user"},
          {"roleId":3,"roleName":"Special user"},
        ],
        modalUserDetailFirstName:"",
        modalUserDetailSurname:"",
        modalUserDetailProvinceArea:[],
        customerTypeNames:{type1:"Normal Customer",type2:"Dealer & Shop Customer",type3:"FTTH Customer"},
        usersTest:[
        {
            "id": 3604,
            "user_code": "VT4583",
            "first_name_la": "ສົມລັກ",
            "surname_la": "ພົມມະຈັນ",
            "phone_number": "02058222966",
            "create_date": "2023-04-30T16:27:32.940Z",
            "last_modify_date": "2023-04-30T16:27:32.940Z",
            "first_name_en": "VILASACK",
            "surname_en": "PHOMMACHACK",
            "gender": 2,
            "dep_name": "ໂທລະສັບມືຖື",
            "section_name": "Drive Test",
            "position_name": "ສະມາຊິກ",
            "role_id": 1,
            "area_code": "VT",
            "status": false,
            "p_name_la": null,
            "p_name_en": null,
            "role_name": "Normal User"
        },
        {
            "id": 3605,
            "user_code": "VT4582",
            "first_name_la": "ເກດ",
            "surname_la": "ວິລະສັກ",
            "phone_number": "02055474690",
            "create_date": "2023-04-30T16:27:32.940Z",
            "last_modify_date": "2023-04-30T16:27:32.940Z",
            "first_name_en": "Ket",
            "surname_en": "VILASACK",
            "gender": 2,
            "dep_name": "ໂທລະສັບມືຖື",
            "section_name": "RNP (Radio NETWORK Planning)",
            "position_name": "ສະມາຊິກ",
            "role_id": 1,
            "area_code": "VT",
            "status": true,
            "p_name_la": null,
            "p_name_en": null,
            "role_name": "Normal User"
        },
        {
            "id": 3608,
            "user_code": "VT4584",
            "first_name_la": "ທະນາພົນ",
            "surname_la": "ປາຊານານຸລັກ",
            "phone_number": "02055590939",
            "create_date": "2023-04-30T16:27:32.940Z",
            "last_modify_date": "2023-04-30T16:27:32.940Z",
            "first_name_en": "Thanaphon",
            "surname_en": "PRASANNANURUK",
            "gender": 2,
            "dep_name": "ວິເຄາະຂໍ້ມູນ ແລະ ພັດທະນາລະບົບ",
            "section_name": null,
            "position_name": "ຮອງຫົວໜ້າພະແນກ",
            "role_id": 2,
            "area_code": "VT",
            "status": false,
            "role_name": "Admin",
            "p_name_la": "ອັດຕະປື",
            "p_name_en": "Auttapue",
            "province_code": "ATP",
            "province_id": 35,
            "districts_id":"291,292,293"
        }
    ],
        users:[],
        modalUserArea:null,
        modalUserAreaFlagAdd:false,
        modalUserAreaSelectedPname:"",
        modalUserAreaProvinces:[],
        modalUserAreaSelectedPCode:null,
        modalUserAreaDistrictsInPv:[],
        allDistrict:[]
        
    };
  },
  mounted() {
    // const modalUserDetail = this.$refs.modalUserDetail;
    var vm = this;
    vm.modalUserDetail = new Modal(document.getElementById('modalUserDetail'));
    vm.getProvinces();
    vm.getDistricts();
    // vm.modalUserDetail.show();
    vm.modalUserArea = new Modal(document.getElementById('modalUserArea'));
 
  },
  methods: {
  validateFormSaveUser:function(){
    var flag = true,
    vm = this,
    msg = "";

    if(vm.modalUserDetailProvinceArea.length==0){
      flag = false;
      msg+= "<div style='float:left'><i class='fa-solid fa-pen-to-square' style='color:red'></i> Province area must be adding! </div><br>";
    }
    if(!vm.modalUserDetailFirstName){
      flag = false;
      msg+= "<div style='float:left'><i class='fa-solid fa-pen-to-square' style='color:red'></i> Fistname must be typing! </div><br>";
    }    
    if(!vm.modalUserDetailSurname){
      flag = false;
      msg+= "<div style='float:left'><i class='fa-solid fa-pen-to-square' style='color:red'></i> Surname must be typing! </div><br>";
    }
    return {"flag":flag,"msg":msg};
  },
  clickSave:function(){
    var vm = this;
    var validateObject = vm.validateFormSaveUser();
    if(!validateObject.flag){
      vm.$swal.fire('Please prepare information to save!', validateObject.msg, 'error');
    }else{
      vm.$swal.fire({
        title: 'Do you want to save data?',
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: 'Send',
        denyButtonText: `Cancel`,
      }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {
          // vm.$swal.fire('Completed!', '', 'success')
          vm.saveData();
        } else if (result.isDenied) {
          // this.$swal.fire('Changes are not saved', '', 'info')
        }
      });
    }
      
    },
    saveData: function(){
      var vm = this;
      vm.modalUserDetail.show();
      var jsonRequest = {};
            jsonRequest.firstName= vm.modalUserDetailFirstName;
            jsonRequest.surname= vm.modalUserDetailSurname;
            jsonRequest.roleId= vm.modalUserDetailSeletedRole.roleId;
            jsonRequest.status= (vm.modalUserDetailUserStatus?1:0);
            jsonRequest.provinceId= vm.modalUserDetailProvinceArea[0].province_id;
            jsonRequest.districtsId= vm.modalUserDetailProvinceArea[0].districts_id;
            jsonRequest.userId= vm.modalUserDetailSelectedId;

      axios.post(Global.backendPath+"user/updateUser", jsonRequest,
            {
              headers: {
              "Authorization": localStorage.getItem("token")
            }
      })
      .then((response) => {
        vm.hideLoading();
        if(response.status==200&&response.statusText=="OK"){
          vm.$swal.fire('Save Completed!', '', 'success');
          vm.modalUserDetail.hide();
          vm.getUserByCondition();
        }else{
          vm.$swal.fire('Can not save question data!', '', 'error');
        }
      }).catch((error) => {
        vm.hideLoading();
        console.log(error);
        vm.isTokenExpire(error);
      });
    },
    validateFormSearch:function(){
    var vm = this,flag = true, msg="";
    if(!vm.keywordToSearch||vm.keywordToSearch.length<4){
      flag = false;
      msg+= "<div style='float:left'><i class='fa-solid fa-pen-to-square' style='color:red;'></i> Keyword length must be grather than 8 character! </div>";
    }
    return {"flag":flag,"msg":msg};
  },
  clickBtnSearch: function(){
    var vm = this;
    var validationObject = vm.validateFormSearch();
    if(!validationObject.flag){
      vm.$swal.fire('Please prepare the information to search!', validationObject.msg, 'error');
    }else{
      vm.getUserByCondition();
    }
  },
   getUserByCondition: async function(){
    var vm = this;
    vm.showLoading();
    var jsonRequest = {};
    jsonRequest.keyword=vm.keywordToSearch;
    // jsonRequest.provinceId=vm.selectedProvinceObject.id;
    // jsonRequest.roleId=vm.selectedRoleObject.roleId
    jsonRequest.provinceId=null;
    jsonRequest.roleId=null;
      return await axios.post(Global.backendPath+"user/getUserByCondition", jsonRequest,
      {
            headers: {
            "Authorization": localStorage.getItem("token")
            }
      })
      .then((response) => {
        vm.hideLoading();
        vm.users = [];
        if(response.status==200&&response.statusText=="OK"&&response.data.result){
          vm.users = response.data.result;
        }
      }).catch((error) => {
        vm.hideLoading();
        console.log(error);
        vm.isTokenExpire(error);
      });
   },
  clickAddBtn:function(){
    var vm = this;
    vm.modalUserDetail.show();
    vm.modalUserDetailFlagSwicthEdit = null;
  },
  clickDelete:function(){
    var vm = this;

      vm.$swal.fire({
        title: 'Do you want to delete this Question?',
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: 'Confirm',
        denyButtonText: `Cancel`,
      }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {
          vm.$swal.fire('Completed!', '', 'success')
          vm.modalUserDetail.hide();
        } else if (result.isDenied) {
          // this.$swal.fire('Changes are not saved', '', 'info')
        }
      });
    },
   getProvinces: async function(){
    var vm = this;
    vm.showLoading();
      return await axios.post(Global.backendPath+"area/getProvinces", {},
      {
            headers: {
            "Authorization": localStorage.getItem("token")
            }
      })
      .then((response) => {
        vm.hideLoading();
        if(response.status==200&&response.statusText=="OK"&&response.data.result){
          vm.provinces=vm.copyJsonObject(response.data.result);
          vm.provinces.push({"code": null,"country_code": null,"create_date": null,
          "id": null,"last_modify_date": null,"name_en": "All",
          "name_la": "ທັງໝົດ"});
          vm.modalUserAreaProvinces=vm.copyJsonObject(response.data.result);
        }
      }).catch((error) => {
        vm.hideLoading();
        console.log(error);
        vm.isTokenExpire(error);
      });
   },
   clickRowUser: function(userData){
    var vm = this;
    vm.resetMdUserDtVariable();
    vm.modalUserDetailSelectedId = userData.id;
    vm.modalUserDetailUserCode = userData.user_code;
    vm.modalUserDetailMobile = userData.phone_number;
    vm.modalUserDetailUserStatus = userData.status;
    vm.modalUserDetailSeletedRole = vm.modalUserDetailRoles[userData.role_id];
    vm.modalUserDetailFirstName = userData.first_name_la;
    vm.modalUserDetailSurname = userData.surname_la;
    if(userData.province_id){
        vm.modalUserDetailProvinceArea = [
        {"province_id":userData.province_id,
        "province_code":userData.province_code,
        "p_name_la":userData.p_name_la,
        "p_name_en":userData.p_name_en,
        "districts_id":userData.districts_id
        },
      ]
    }

    vm.modalUserDetail.show();
   },
   clickRowProvince: function(provinceCode,provinceName,existingDistrictsId){
    var vm = this;
    vm.resetMdUserAreaVariable();
    vm.modalUserArea.show();
      if(vm.modalUserAreaFlagAdd){
      //*****Check wheater new selected province is dupplicate with exiting provinces in modal Question Detail or not?
      var result = vm.modalUserDetailProvinceArea.filter(district => district.province_code == provinceCode);
            if(result.length>0){
              vm.$swal.fire('Can not select province "'+provinceName+"\", it's duplicating with existing one!", '', 'error');
            }else{
              vm.setAreaData(provinceCode,provinceName);
            }
      }else{
              vm.setAreaData(provinceCode,provinceName,existingDistrictsId);
      }
    },
    resetMdUserDtVariable: function(){
      var vm = this;
      vm.modalUserDetailSelectedId = null;
      vm.modalUserDetailFlagSwicthEdit=false;
      vm.modalUserDetailUserCode=null;
      vm.modalUserDetailMobile=null;
      vm.modalUserDetailUserStatus=true;
      vm.modalUserDetailSeletedRole=null;
      vm.modalUserDetailFirstName="";
      vm.modalUserDetailSurname="";
      vm.modalUserDetailProvinceArea=[];
    },
    resetMdUserAreaVariable: function(){
      var vm = this;
      vm.modalUserAreaSelectedPname="";
      vm.modalUserAreaSelectedPCode=null;
      vm.modalUserAreaDistrictsInPv=[];

    },
    setAreaData: function(provinceCode,provinceName,existingDistrictsId){
      var vm = this;
          vm.modalUserAreaSelectedPCode = provinceCode;
          vm.modalUserAreaSelectedPname = provinceName;

      var districts = vm.allDistrict.filter(district => district.province_code == provinceCode);
          vm.modalUserAreaDistrictsInPv = vm.copyJsonObject(districts);
          //******existingDistrictsId come from click province in modal Question Detail 
          if(existingDistrictsId){
                var districtsIdArray = existingDistrictsId.split(",");
                for(var idx=0;idx<districtsIdArray.length;idx++){
                      var districtId = districtsIdArray[idx];
                      var currentDistricts = vm.modalUserAreaDistrictsInPv.filter(district => district.id == districtId);
                      currentDistricts[0].isActive = true;
                }
          }
   },
   getDistricts: async function(){
    var vm = this;
    // vm.showLoading();
      return await axios.post(Global.backendPath+"area/getDistricts", {},
      {
            headers: {
            "Authorization": localStorage.getItem("token")
            }
      })
      .then((response) => {
        vm.hideLoading();
        if(response.status==200&&response.statusText=="OK"&&response.data.result){
          vm.allDistrict=response.data.result;
        }
      }).catch((error) => {
        vm.hideLoading();
        console.log(error);
        vm.isTokenExpire(error);
      });
   },
   clickDeleteAreaProvince: function(userArea){
    var vm = this;
    vm.$swal.fire({
        title: 'Do you want to delete province '+userArea.province_code+', '+userArea.p_name_la+'/'+userArea.p_name_en+' for user area?',
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: 'Confirm',
        denyButtonText: `Cancel`,
      }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {
            vm.modalUserDetailProvinceArea=[];
        }
      });

   },
   clickBtnAddProvince: function(){
    var vm = this;
    vm.resetMdUserAreaVariable();
    vm.modalUserAreaFlagAdd = true;
    vm.modalUserArea.show();
   },
   clickOkChooseDistricts: function(){
    var vm = this;
    var districsComma = "";
    for(var idx=0;idx<vm.modalUserAreaDistrictsInPv.length;idx++){
      var currentDistrict = vm.modalUserAreaDistrictsInPv[idx];
      if(currentDistrict.isActive){
        districsComma+=(districsComma!=""?",":"")+currentDistrict.id
      }
    }
    var existingProvince= vm.modalUserDetailProvinceArea.filter(item => item.province_code === vm.modalUserAreaSelectedPCode)
    if(existingProvince.length>0){
      existingProvince[0].districts_id = districsComma;
    }else{
      var provinceObject = vm.getProvinceObjectFromPcode(vm.modalUserAreaSelectedPCode);
      var newAreaData ={
      province_code: vm.modalUserAreaSelectedPCode,
      districts_id: districsComma,
      province_id:provinceObject.id,
      p_name_en: provinceObject.name_en,
      p_name_la: provinceObject.name_la}
      vm.modalUserDetailProvinceArea.push(newAreaData);
    }
    vm.modalUserArea.hide();
   },
   getProvinceObjectFromPcode: function(provinceCode){
    var vm = this;
    if(provinceCode){
    var provinceAr = vm.modalUserAreaProvinces.filter(item => item.code === provinceCode)
    var provinceData = provinceAr[0];
      return provinceData;
    }else{
      return "";
    }
   },
   clickBtnSyncUserData: function(){
    var vm = this;
    vm.$swal.fire({
        title: 'Do you want to sync user data from LTC-HR?',
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: 'Yes',
        denyButtonText: `No`,
      }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {
            vm.modalUserDetailProvinceArea=[];
        }
      });
   },
   onChangeCbDistrict: function(id){
    //To uncheck district checkbox which id is not the same with inject id
    var vm = this;
    for(var idx=0;idx<vm.modalUserAreaDistrictsInPv.length;idx++){
      var district = vm.modalUserAreaDistrictsInPv[idx];
      if(district.id!=id){
        district.isActive = false;
      }
    }
     
   }
},
};
</script>

<style scoped>
.otp-keypad {
  max-width: 50%;
  margin: 0 auto;
}

.otp-keypad-button {
  font-size: 1.5rem;
  font-weight: bold;
  border-radius: 50%;
  height: 60px;
  width: 60px;
  line-height: 60px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
  background-color: #f1f1f1;
  border: none;
  outline: none;
  color: #333;
}

.otp-keypad-empty-space {
  height: 60px;
  width: 60px;
  background-color: transparent;
}

.nav-link.active {
  background-color: gray;
}
</style>
